import React, { useState, useEffect  } from 'react';
import { useNavigate } from 'react-router-dom';
import ImagesAll from '../assets';
import { getCurrentUser, getUserNameOpt, resetOnlogout } from '../utils';
import { useAuth } from '../Context';
import '../css/userdetails.css'; // Create this CSS file for styling

const UserDetails = () => {
    const { onLogoutContext } = useAuth();
    const [showPopup, setShowPopup] = useState(true);
    const navigate = useNavigate();

    const [currentUserData, setCurrentUserData] = useState(getCurrentUser());

    useEffect(() => {
      setCurrentUserData(getCurrentUser());
    }, [getCurrentUser]);

    const currentUser = currentUserData || null;
    const profilePhoto = currentUser?.profilePhotoPath || null;
    const userFullName = getUserNameOpt() || '';
  
    const logout = () => {
      onLogoutContext();
      resetOnlogout();
      navigate("/login");
    }

  return (
    <div className="user-details-container w3-round w3-card-2">
      <div className="user-profile-ele" onClick={() => setShowPopup(!showPopup)}>
        <img 
          src={profilePhoto ? process.env.REACT_APP_API_URL+'/'+profilePhoto : ImagesAll.Members.NoImg} 
          alt={userFullName} 
          className="user-image-popup" 
        />
        <p className="user-name color-purple roboto-bold">{userFullName}</p>
        <div className='logout roboto-medium' onClick={logout}>Log out</div>
      </div>

      {showPopup && ( // Conditionally render the popup
        <div className='user-d-table w3-padding-large w3-padding-24'>
            <table className='w3-table'>
                <thead></thead>
                <tbody>
                    <tr>
                        <td>Job Title</td>
                        <td className='roboto-medium'>{currentUser.designation || ""}</td>
                    </tr>
                    <tr>
                        <td>Company</td>
                        <td className='roboto-medium'>{currentUser.organization || ""}</td>
                    </tr>
                    <tr>
                        <td>Email</td>
                        <td className='roboto-medium'>{currentUser.emailId || ""}</td>
                    </tr>
                </tbody>
            </table>
        </div>
      )}
    </div>
  );
};

export default UserDetails;
